import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { style: {"padding":"10px 20px"} }
const _hoisted_2 = {
  key: 0,
  style: {"color":"var(--el-text-color-secondary)"}
}

import { computed } from "vue"
import { useComTuonti } from "./tuonti"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComVarmistus',
  setup(__props) {

const {
    huonekortit,
    vastuuyksikko,
    vastuuyksikot,
    kopioiLiitteet,
    tilatPerHuonekortti,
    setTilojenMaara,
    setTilatunnus,
    peruuta,
    hyvaksy
} = useComTuonti()

const maara = computed(() => huonekortit.value.length)
const vastuuyksikkoNimi = computed(() => vastuuyksikot.value?.find((v) => v.id === vastuuyksikko.value)?.nimi)

const huonekorttiRows = computed(() =>
    huonekortit.value.map((h) => ({
        id: h.id,
        nimi: h.nimi
    }))
)

const getTilojenMaara = (id: number) => {
    return tilatPerHuonekortti.value[id]?.length ?? 0
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, { class: "card-margin-bottom" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createTextVNode("Olet tuomassa " + _toDisplayString(maara.value) + " huonekorttia vastuuyksikköön " + _toDisplayString(vastuuyksikkoNimi.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: huonekorttiRows.value,
      stripe: "",
      class: "card-margin-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "nimi",
          label: "Huonekortti",
          "min-width": "200"
        }),
        _createVNode(_component_el_table_column, {
          label: "Tilojen määrä",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_input_number, {
              "model-value": getTilojenMaara(row.id),
              "onUpdate:modelValue": (val) => _unref(setTilojenMaara)(row.id, val ?? 0),
              min: 0,
              size: "small"
            }, null, 8, ["model-value", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          type: "expand",
          width: "50"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(tilatPerHuonekortti)[row.id] ?? []), (tila, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {"margin-bottom":"8px"}
                }, [
                  _createVNode(_component_el_input, {
                    "model-value": tila.tilatunnus ?? '',
                    "onUpdate:modelValue": (val) => _unref(setTilatunnus)(row.id, index, val),
                    placeholder: 'Tilatunnus ' + (index + 1),
                    size: "small"
                  }, null, 8, ["model-value", "onUpdate:modelValue", "placeholder"])
                ]))
              }), 128)),
              (getTilojenMaara(row.id) === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Ei tiloja "))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_row, { class: "card-margin-bottom" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: _unref(kopioiLiitteet),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(kopioiLiitteet) ? (kopioiLiitteet).value = $event : null)),
              label: "Kopioi myös huonekorttien liitteet",
              border: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { justify: "end" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { push: 18 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "small",
              type: "danger",
              class: "button",
              onClick: _unref(peruuta)
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Peruuta", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "success",
              class: "button",
              onClick: _unref(hyvaksy)
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Tuo huonekortit", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})